var map = {
  "./config/dashpanels": "57948",
  "./modules/admin/dashpanels": "37543",
  "./modules/gndo/dashpanels": "10556",
  "./modules/pagebox/dashpanels": "76418",
  "./modules/restriction/dashpanels": "46112",
  "./modules/stats/dashpanels": "3971",
  "./modules/timeline/dashpanels": "2045"
};


function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then(__webpack_require__);
}
function __rspack_async_context_resolve(req) {
  return Promise.all(/* lazy-once context | core */ [__webpack_require__.e("rbush-node_modules_rbush_rbush_min_js"), __webpack_require__.e("vendors-node_modules_date-fns_esm_differenceInYears_index_js-node_modules_date-fns_esm_getDat-28ce70"), __webpack_require__.e("src_modules_serverlog_utils_js-src_tree_rules_js-src_viewer_layouts_js"), __webpack_require__.e("core")]).then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 86945;
module.exports = __rspack_async_context;
